module.exports = "<!--The content below is only a placeholder and can be replaced.-->\r\n<div class=\"app\" style=\"background-color:#f8f9fa; min-height: 100vh; \">\r\n <div class=\"container\" > \r\n\r\n<app-navbar  ></app-navbar>\r\n<!--<div class=\"kuva\" >\r\n    \r\n        <div style=\"text-align:center\">\r\n            <img height=\"150\" src=\"/assets/img/sarvet-transparent.png\" > \r\n          </div>-->\r\n      \r\n   \r\n\r\n\r\n\r\n  <router-outlet></router-outlet>\r\n</div> \r\n\r\n</div> \r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main